import React, { useState } from 'react';

import { SearchOutlined } from '@ant-design/icons/lib';

import {
  TableFilterBarContainer,
  TableFilterBarFilters,
  TableFilterBarReset,
  TableFilterBarResetContainer,
  TableFilterBarSearch,
} from 'common/TableFilterBar/TableFilterBar';
import SelectAdvancedFilterRadio from 'components/lib/SelectAdvancedFilterRadio';
import { CmiDigestWatchlistType } from 'types/cmiDigestWatchlist';

import { TYPE_FILTER_OPTIONS } from './constants';

type Props = {
  typeFilter: CmiDigestWatchlistType;
  onTypeFilterChange: (type: CmiDigestWatchlistType) => void;
  onSearchChange: (search: string) => void;
  onReset: () => void;
};

const CommunitiesToWatchFilters = ({ typeFilter, onTypeFilterChange, onSearchChange, onReset }: Props) => {
  // The search input is left uncontrolled (see below) so typing stays instant despite the
  // debounce - remounting it via this key is what clears its visible text on Reset instead.
  const [searchInputKey, setSearchInputKey] = useState(0);

  const handleReset = () => {
    setSearchInputKey((key) => key + 1);
    onReset();
  };

  return (
    <TableFilterBarContainer>
      <TableFilterBarFilters>
        <SelectAdvancedFilterRadio
          placeholder="Type"
          options={TYPE_FILTER_OPTIONS}
          defaultValue={typeFilter}
          onSelect={onTypeFilterChange}
        />
        <TableFilterBarResetContainer>
          <TableFilterBarReset onClick={handleReset}>Reset</TableFilterBarReset>
        </TableFilterBarResetContainer>
      </TableFilterBarFilters>
      <TableFilterBarSearch
        key={searchInputKey}
        prefix={<SearchOutlined />}
        placeholder="Search communities"
        onChange={(e) => onSearchChange(e?.target?.value ?? '')}
      />
    </TableFilterBarContainer>
  );
};

export default CommunitiesToWatchFilters;
